export default __webpack_public_path__ + "static/media/jumoke.7bec65c5.png";